document.addEventListener('DOMContentLoaded', () => {
	const accordions = document.querySelectorAll('.wp-block-knightowl-blocks-accordion');

	accordions.forEach(accordion => {
		accordion.addEventListener('click', e => {
			const button = e.target.closest('.accordion-button');
			if (button) {
				const currentContent = button.closest('.wp-block-knightowl-blocks-accordion-item').querySelector('.accordion-content');

				// Check if 'accordion-keep-one-open' is enabled
				const keepOneOpen = accordion.classList.contains('accordion-keep-one-open');

				if (!accordion.classList.contains('accordion-expand-multiple')) {
					const allButtons = accordion.querySelectorAll('.accordion-button');
					const allContents = accordion.querySelectorAll('.accordion-content');

					allButtons.forEach(btn => {
						if (btn !== button) {
							btn.classList.remove('is-active');
							btn.setAttribute('aria-expanded', 'false');
						}
					});

					allContents.forEach(content => {
						if (content !== currentContent) {
							if (!keepOneOpen || allContents.length !== 1) {
								content.classList.remove('show');
							}
						}
					});
				}

				if (keepOneOpen && currentContent.classList.contains('show') && accordion.querySelectorAll('.accordion-content.show').length <= 1) {
					e.preventDefault();
					return;
				}

				if (currentContent.classList.contains('show')) {
					button.classList.remove('is-active');
					button.setAttribute('aria-expanded', 'false');
					currentContent.classList.remove('show');
				} else {
					button.classList.add('is-active');
					button.setAttribute('aria-expanded', 'true');
					currentContent.classList.add('show');
				}

				// Enhanced image feature
				if (accordion.classList.contains('accordion-image-enhanced')) {
					const imageHolder = accordion.querySelector('.image-enhanced-holder');
					if (imageHolder) {
						const enhancedImage = button.closest('.accordion-header').getAttribute('data-enhanced-image');
						const enhancedImageAlt = button.closest('.accordion-header').getAttribute('data-enhanced-image-alt') || '';
						
						const accordionItem = button.closest('.wp-block-knightowl-blocks-accordion-item');
						imageHolder.className = 'image-enhanced-holder';
						accordionItem.classList.forEach(className => {
							if (className.startsWith('is-style-accordion-enhanced-image-')) {
								imageHolder.classList.add(className);
							}
						});

						imageHolder.innerHTML = '';
						if (enhancedImage) {
							const imgElement = document.createElement('img');
							imgElement.src = enhancedImage;
							imgElement.alt = enhancedImageAlt;
							imgElement.style.opacity = 1;
							imageHolder.appendChild(imgElement);
						}
					}
				}

				e.preventDefault();
			}
		});

		// Initial image display for active item on load
		if (accordion.classList.contains('accordion-image-enhanced')) {
			const activeButton = accordion.querySelector('.accordion-button.is-active');
			if (activeButton) {
				const imageHolder = accordion.querySelector('.image-enhanced-holder');
				const enhancedImage = activeButton.closest('.accordion-header').getAttribute('data-enhanced-image');
				const enhancedImageAlt = activeButton.closest('.accordion-header').getAttribute('data-enhanced-image-alt') || '';
				
				if (imageHolder && enhancedImage) {
					const accordionItem = activeButton.closest('.wp-block-knightowl-blocks-accordion-item');
					imageHolder.className = 'image-enhanced-holder';
					accordionItem.classList.forEach(className => {
						if (className.startsWith('is-style-accordion-enhanced-image-')) {
							imageHolder.classList.add(className);
						}
					});

					imageHolder.innerHTML = '';
					const imgElement = document.createElement('img');
					imgElement.src = enhancedImage;
					imgElement.alt = enhancedImageAlt;
					imgElement.style.opacity = 1;
					imageHolder.appendChild(imgElement);
				}
			}
		}
	});

	// Open accordion item by element ID
	function openAccordionById(id) {
		const target = document.getElementById(id);
		if (!target) return;

		const accordionItem = target.classList.contains('wp-block-knightowl-blocks-accordion-item')
			? target
			: target.closest('.wp-block-knightowl-blocks-accordion-item');

		if (accordionItem) {
			const button = accordionItem.querySelector('.accordion-button');
			if (button && !button.classList.contains('is-active')) {
				button.click();
			}
		}
	}

	// Wait for scroll to finish, then open accordion
	function openAccordionAfterScroll(id) {
		let scrollTimeout;
		function onScrollEnd() {
			clearTimeout(scrollTimeout);
			scrollTimeout = setTimeout(() => {
				window.removeEventListener('scroll', onScrollEnd);
				openAccordionById(id);
			}, 150);
		}
		window.addEventListener('scroll', onScrollEnd);
		onScrollEnd();
	}

	// Open on page load if hash is present
	if (window.location.hash) {
		openAccordionAfterScroll(window.location.hash.substring(1));
	}

	// Open on hash change
	window.addEventListener('hashchange', () => {
		if (window.location.hash) {
			openAccordionAfterScroll(window.location.hash.substring(1));
		}
	});

	// Open when clicking a hash link that points to an accordion item
	document.addEventListener('click', (e) => {
		const link = e.target.closest('a[href*="#"]');
		if (!link) return;

		const hash = link.getAttribute('href').split('#')[1];
		if (hash) {
			openAccordionAfterScroll(hash);
		}
	});
});
